/**
 * Utilitaire pour générer le template Excel d'import d'entrées.
 * Ce fichier est NOUVEAU et n'affecte pas les utilitaires existants.
 *
 * Utilise exceljs pour générer un vrai fichier Excel (.xlsx)
 */
import ExcelJS from "exceljs";

/**
 * Génère et télécharge le template Excel pour l'import d'entrées
 */
export const generateEntreesTemplate = async () => {
  try {
    // Créer un nouveau workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Entrées");

    // Définir les colonnes
    worksheet.columns = [
      { header: "Date", key: "date", width: 15 },
      { header: "Intitulé", key: "intitule", width: 25 },
      { header: "Client", key: "client", width: 25 },
      { header: "Compte Client", key: "compte_client", width: 18 },
      { header: "Source paiement", key: "source_paiement", width: 20 },
      { header: "Taxes", key: "taxes", width: 10 },
      { header: "Remise", key: "remise", width: 10 },
      { header: "Montant payé", key: "montant_paye", width: 15 },
      { header: "Nom produit", key: "nom_produit", width: 25 },
      { header: "Description", key: "description", width: 30 },
      { header: "Compte de Produit", key: "compte_produit", width: 18 },
      { header: "Quantité", key: "quantite", width: 12 },
      { header: "Prix unitaire", key: "prix_unitaire", width: 15 },
    ];

    // Styliser l'en-tête
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF009688" },
    };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.height = 25;

    // Ajouter des lignes d'exemple
    const exampleRows = [
      {
        date: "15/01/2026",
        intitule: "Vente janvier",
        client: "Client Test A",
        compte_client: "41110025",
        source_paiement: "banque",
        taxes: 18,
        remise: 0,
        montant_paye: 50000,
        nom_produit: "Ordinateur Portable",
        description: "Dell Latitude 5420",
        compte_produit: "706100",
        quantite: 1,
        prix_unitaire: 500000,
      },
      {
        date: "15/01/2026",
        intitule: "Vente janvier",
        client: "Client Test A",
        compte_client: "41110025",
        source_paiement: "banque",
        taxes: 18,
        remise: 0,
        montant_paye: 50000,
        nom_produit: "Souris Sans Fil",
        description: "Logitech MX Master",
        compte_produit: "701100",
        quantite: 2,
        prix_unitaire: 25000,
      },
      {
        date: "16/01/2026",
        intitule: "Vente février",
        client: "Client Test B",
        compte_client: "",
        source_paiement: "caisse",
        taxes: 18,
        remise: 5,
        montant_paye: 100000,
        nom_produit: "Clavier Mécanique",
        description: "RGB Gaming",
        compte_produit: "",
        quantite: 1,
        prix_unitaire: 75000,
      },
    ];

    // Ajouter les lignes d'exemple
    exampleRows.forEach((row) => {
      worksheet.addRow(row);
    });

    // Styliser les lignes d'exemple (alternance de couleurs)
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin", color: { argb: "FFD3D3D3" } },
            left: { style: "thin", color: { argb: "FFD3D3D3" } },
            bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
            right: { style: "thin", color: { argb: "FFD3D3D3" } },
          };
          cell.alignment = { vertical: "middle" };
        });

        // Alternance de couleurs
        if (rowNumber % 2 === 0) {
          row.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F5F5" },
          };
        }
      }
    });

    // Ajouter une feuille d'instructions
    const instructionsSheet = workbook.addWorksheet("Instructions");
    instructionsSheet.columns = [{ width: 80 }];

    const instructions = [
      {
        text: "INSTRUCTIONS POUR L'IMPORT D'ENTRÉES",
        bold: true,
        size: 16,
        color: "009688",
      },
      { text: "" },
      { text: "FORMAT DU FICHIER :", bold: true, size: 12 },
      { text: "• Le fichier doit contenir 13 colonnes dans l'ordre indiqué" },
      {
        text: "• La première ligne doit contenir les en-têtes (ne pas modifier)",
      },
      { text: "• Les lignes suivantes contiennent les données" },
      { text: "" },
      { text: "COLONNES REQUISES :", bold: true, size: 12 },
      { text: "1. Date (format: JJ/MM/AAAA) - OBLIGATOIRE" },
      { text: "2. Intitulé - OBLIGATOIRE" },
      { text: "3. Client - OBLIGATOIRE" },
      { text: "4. Compte Client - Optionnel (ex: 41110025, classe 4, si vide auto-généré)" },
      {
        text: "5. Source paiement (banque, caisse, wave, orange_money) - Optionnel",
      },
      { text: "6. Taxes (pourcentage, ex: 18) - Optionnel" },
      { text: "7. Remise (pourcentage, ex: 5) - Optionnel" },
      { text: "8. Montant payé - Optionnel" },
      { text: "9. Nom produit - OBLIGATOIRE" },
      { text: "10. Description - Optionnel" },
      { text: "11. Compte de Produit - Optionnel (ex: 701, 706, classe 7, si vide IA génère)" },
      { text: "12. Quantité - OBLIGATOIRE (doit être > 0)" },
      { text: "13. Prix unitaire - OBLIGATOIRE (doit être > 0)" },
      { text: "" },
      { text: "RÈGLES DE GROUPEMENT :", bold: true, size: 12 },
      {
        text: "Les lignes avec la même Date, le même Intitulé et le même Client",
      },
      {
        text: "seront regroupées en UNE SEULE entrée avec plusieurs produits.",
      },
      { text: "" },
      { text: "EXEMPLE :", bold: true, size: 12 },
      { text: "Si vous avez 3 lignes avec :" },
      { text: "  • Date: 15/01/2026" },
      { text: "  • Intitulé: Vente janvier" },
      { text: "  • Client: Client A" },
      { text: "→ Résultat : 1 entrée avec 3 produits" },
      { text: "" },
      { text: "CODES COMPTABLES :", bold: true, size: 12 },
      { text: "COMPTE CLIENT (colonne 4) :" },
      { text: "  • Optionnel : peut être laissé vide" },
      { text: "  • Format : numérique, 3 à 12 chiffres" },
      { text: "  • Classe : doit commencer par 4 (tiers SYSCOHADA)" },
      { text: "  • Exemples valides : 41110001, 41118001, 4111" },
      { text: "  • Si vide : auto-généré (41110001, 41110002, etc.)" },
      { text: "" },
      { text: "COMPTE DE PRODUIT (colonne 11) :" },
      { text: "  • Optionnel : peut être laissé vide" },
      { text: "  • Format : numérique, 3 à 12 chiffres" },
      { text: "  • Classe : doit commencer par 7 (produits SYSCOHADA)" },
      { text: "  • Codes courts (3 chiffres) : 701 (marchandises), 706 (services), 702 (produits finis)" },
      { text: "  • Codes complets (6 chiffres) : 701100 (marchandises), 706100 (services), 702100 (produits finis)" },
      { text: "  • Si vide : IA génère automatiquement basé sur SYSCOHADA" },
      { text: "" },
      { text: "CLIENTS :", bold: true, size: 12 },
      { text: "Si un client n'existe pas, il sera créé automatiquement." },
      { text: "  • Code comptable : selon colonne 4 ou auto-généré" },
      { text: "" },
      { text: "TAILLE MAXIMALE :", bold: true, size: 12 },
      { text: "10 MB par fichier" },
      { text: "" },
      { text: "FORMATS ACCEPTÉS :", bold: true, size: 12 },
      { text: ".xlsx, .xls" },
    ];

    instructions.forEach((instruction, index) => {
      const row = instructionsSheet.getRow(index + 1);
      row.getCell(1).value = instruction.text;

      if (instruction.bold) {
        row.getCell(1).font = {
          bold: true,
          size: instruction.size || 11,
          color: instruction.color
            ? { argb: `FF${instruction.color}` }
            : undefined,
        };
      }

      row.getCell(1).alignment = {
        vertical: "top",
        wrapText: true,
      };
      row.height = 20;
    });

    // Générer le fichier
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Télécharger le fichier
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "template_import_entrees.xlsx");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Erreur lors de la génération du template:", error);
    throw error;
  }
};

/**
 * Valide un fichier avant upload
 * @param {File} file - Fichier à valider
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateExcelFile = (file) => {
  // Vérifier que le fichier existe
  if (!file) {
    return {
      valid: false,
      error: "Aucun fichier sélectionné",
    };
  }

  // Vérifier l'extension
  const validExtensions = [".xlsx", ".xls"];
  const fileName = file.name.toLowerCase();
  const isValidExtension = validExtensions.some((ext) =>
    fileName.endsWith(ext),
  );

  if (!isValidExtension) {
    return {
      valid: false,
      error: "Format de fichier invalide. Formats acceptés : .xlsx, .xls",
    };
  }

  // Vérifier la taille (max 10 MB)
  const maxSize = 10 * 1024 * 1024; // 10 MB
  if (file.size > maxSize) {
    return {
      valid: false,
      error: "Le fichier est trop volumineux. Taille maximale : 10 MB",
    };
  }

  return {
    valid: true,
    error: null,
  };
};

export default {
  generateEntreesTemplate,
  validateExcelFile,
};
